// AUTOGENERATED FILE - DO NOT EDIT

/**
 * All IAM policy actions for AWS Systems Manager Incident Manager (SSM-INCIDENTS)
 *
 * Extracted by `aws-iam-policy` from
 * https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssystemsmanagerincidentmanager.html
 *
 * 2025-02-24T21:49:56.207Z
 */
export enum AwsSsmIncidentsActions {
  /**
   * Grants permission to retrieve details about specified findings for an incident
   * record
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_BatchGetIncidentFindings.html
   */
  BatchGetIncidentFindings = 'ssm-incidents:BatchGetIncidentFindings',
  /**
   * Grants permission to create a replication set
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_CreateReplicationSet.html
   */
  CreateReplicationSet = 'ssm-incidents:CreateReplicationSet',
  /**
   * Grants permission to create a response plan
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_CreateResponsePlan.html
   */
  CreateResponsePlan = 'ssm-incidents:CreateResponsePlan',
  /**
   * Grants permission to create a timeline event for an incident record
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_CreateTimelineEvent.html
   */
  CreateTimelineEvent = 'ssm-incidents:CreateTimelineEvent',
  /**
   * Grants permission to delete an incident record
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_DeleteIncidentRecord.html
   */
  DeleteIncidentRecord = 'ssm-incidents:DeleteIncidentRecord',
  /**
   * Grants permission to delete a replication set
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_DeleteReplicationSet.html
   */
  DeleteReplicationSet = 'ssm-incidents:DeleteReplicationSet',
  /**
   * Grants permission to delete resource policy from a response plan
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_DeleteResourcePolicy.html
   */
  DeleteResourcePolicy = 'ssm-incidents:DeleteResourcePolicy',
  /**
   * Grants permission to delete a response plan
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_DeleteResponsePlan.html
   */
  DeleteResponsePlan = 'ssm-incidents:DeleteResponsePlan',
  /**
   * Grants permission to delete a timeline event
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_DeleteTimelineEvent.html
   */
  DeleteTimelineEvent = 'ssm-incidents:DeleteTimelineEvent',
  /**
   * Grants permission to view the contents of an incident record
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_GetIncidentRecord.html
   */
  GetIncidentRecord = 'ssm-incidents:GetIncidentRecord',
  /**
   * Grants permission to view the replication set
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_GetReplicationSet.html
   */
  GetReplicationSet = 'ssm-incidents:GetReplicationSet',
  /**
   * Grants permission to view resource policies of a response plan
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_GetResourcePolicies.html
   */
  GetResourcePolicies = 'ssm-incidents:GetResourcePolicies',
  /**
   * Grants permission to view the contents of a specified response plan
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_GetResponsePlan.html
   */
  GetResponsePlan = 'ssm-incidents:GetResponsePlan',
  /**
   * Grants permission to view a timeline event
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_GetTimelineEvent.html
   */
  GetTimelineEvent = 'ssm-incidents:GetTimelineEvent',
  /**
   * Grants permission to list findings for an incident record
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_ListIncidentFindings.html
   */
  ListIncidentFindings = 'ssm-incidents:ListIncidentFindings',
  /**
   * Grants permission to list the contents of all incident records
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_ListIncidentRecords.html
   */
  ListIncidentRecords = 'ssm-incidents:ListIncidentRecords',
  /**
   * Grants permission to list related items of an incident record
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_ListRelatedItems.html
   */
  ListRelatedItems = 'ssm-incidents:ListRelatedItems',
  /**
   * Grants permission to list all replication sets
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_ListReplicationSets.html
   */
  ListReplicationSets = 'ssm-incidents:ListReplicationSets',
  /**
   * Grants permission to list all response plans
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_ListResponsePlans.html
   */
  ListResponsePlans = 'ssm-incidents:ListResponsePlans',
  /**
   * Grants permission to view a list of resource tags for a specified resource
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_ListTagsForResource.html
   */
  ListTagsForResource = 'ssm-incidents:ListTagsForResource',
  /**
   * Grants permission to list all timeline events for an incident record
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_ListTimelineEvents.html
   */
  ListTimelineEvents = 'ssm-incidents:ListTimelineEvents',
  /**
   * Grants permission to put resource policy on a response plan
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_PutResourcePolicy.html
   */
  PutResourcePolicy = 'ssm-incidents:PutResourcePolicy',
  /**
   * Grants permission to start a new incident using a response plan
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_StartIncident.html
   */
  StartIncident = 'ssm-incidents:StartIncident',
  /**
   * Grants permission to add tags to a response plan
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_TagResource.html
   */
  TagResource = 'ssm-incidents:TagResource',
  /**
   * Grants permission to remove tags from a response plan
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_UntagResource.html
   */
  UntagResource = 'ssm-incidents:UntagResource',
  /**
   * Grants permission to update replication set deletion protection
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_UpdateDeletionProtection.html
   */
  UpdateDeletionProtection = 'ssm-incidents:UpdateDeletionProtection',
  /**
   * Grants permission to update the contents of an incident record
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_UpdateIncidentRecord.html
   */
  UpdateIncidentRecord = 'ssm-incidents:UpdateIncidentRecord',
  /**
   * Grants permission to update related items of an incident record
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_UpdateRelatedItems.html
   */
  UpdateRelatedItems = 'ssm-incidents:UpdateRelatedItems',
  /**
   * Grants permission to update a replication set
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_UpdateReplicationSet.html
   */
  UpdateReplicationSet = 'ssm-incidents:UpdateReplicationSet',
  /**
   * Grants permission to update the contents of a response plan
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_UpdateResponsePlan.html
   */
  UpdateResponsePlan = 'ssm-incidents:UpdateResponsePlan',
  /**
   * Grants permission to update a timeline event
   *
   * See https://docs.aws.amazon.com/incident-manager/latest/APIReference/API_UpdateTimelineEvent.html
   */
  UpdateTimelineEvent = 'ssm-incidents:UpdateTimelineEvent',
}
